// sentry.ts
import * as Sentry from "@sentry/react";
import * as React from "react";
import * as RouterDOM from "react-router-dom";

let _useSentryRoutes: typeof RouterDOM.useRoutes;
let _SentryRoutes: typeof RouterDOM.Routes;

export default function init(appName: string, env: string, release?: string) {
  Sentry.init({
    dsn: "https://eaac13f208e63924d8d71342890dd334@o4509541473255424.ingest.de.sentry.io/4509541475483728",
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        ...RouterDOM,
        useEffect: React.useEffect,
      }),
    ],
    tracesSampleRate: 1.0,
    release: release ?? `${appName}@1.0.0`,
    environment: env,
  });

  Sentry.setTag("app", appName); // set global tag

  _useSentryRoutes = Sentry.wrapUseRoutesV6(RouterDOM.useRoutes);
  _SentryRoutes = Sentry.withSentryReactRouterV6Routing(RouterDOM.Routes);
}

export const useSentryRoutes = (
  ...args: Parameters<typeof RouterDOM.useRoutes>
) => {
  if (!_useSentryRoutes) throw new Error("Sentry not initialized");
  return _useSentryRoutes(...args);
};

export const SentryRoutes = (
  props: React.ComponentProps<typeof RouterDOM.Routes>,
) => {
  if (!_SentryRoutes) throw new Error("Sentry not initialized");
  return React.createElement(_SentryRoutes, props);
};
